export default __webpack_public_path__ + "static/facebookconnect-e6afec2484aad88372e667e3b62719ef.png";